import type { Coding } from "@medplum/fhirtypes";
import { ICD_10_CM_SYSTEM as ICD_10_CM_URL } from "@repo/fhir-systems";
import { useNlmSearch } from "@/shared/hooks/use-nlm-search";

const NLM_API = "https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search";

export interface IcdCodeOption {
  code: string;
  display: string;
  system: string;
  coding: Coding;
}

const searchConfig = {
  endpoint: NLM_API,
  params: "sf=code,name",
  parse(data: [number, string[], null, [string, string][]]): IcdCodeOption[] {
    const entries = data[3] ?? [];
    return entries.map(([code, display]) => ({
      code,
      display,
      system: ICD_10_CM_URL,
      coding: { system: ICD_10_CM_URL, code, display },
    }));
  },
};

export function useIcdCodeSearch(query: string) {
  return useNlmSearch(query, searchConfig);
}
